//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The constant identifier for the 3D {@link SceneMode}\n\
 *\n\
 * @name czm_sceneMode3D\n\
 * @glslConstant\n\
 * @see czm_sceneMode\n\
 * @see czm_sceneMode2D\n\
 * @see czm_sceneModeColumbusView\n\
 * @see czm_sceneModeMorphing\n\
 */\n\
const float czm_sceneMode3D = 3.0;\n\
";
